import { c as _c } from "react/compiler-runtime";
import type React from 'react';
type MarginsLayoutProps = {
  children: React.ReactNode;
};
export function MarginsLayout(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <section className="mx-auto max-w-xl lg:max-w-7xl">{children}</section>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}